import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/admin/login");
        return;
      }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res.data?.session_token) localStorage.setItem("bw_token", res.data.session_token);
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard");
      } catch {
        navigate("/admin/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      <p className="font-serif text-2xl text-matte/60">Entering the studio…</p>
    </div>
  );
}
